export default __webpack_public_path__ + "static/me-md-5121d5e7ef94b6aea688c7b3a2f65646.png";